import { IAvLoaderProps } from "./types";

export const loaderSetAction = ({ message, isVisible }: IAvLoaderProps) => ({
  type: 'LOADER_SET',
  payload: {
    isVisible,
    message
  }
});
